import cloneDeep from 'lodash/fp/cloneDeep'
import {
  VALIDATE_RATING,
  SET_METADVISOR,
  SET_APPOINTADVISOR,
  SET_EMAIL,
  SET_RATING,
  SET_ADVISER_ID,
  SUBMITTED_RATING,
  SUBMITTING_RATING,
  SET_RESPONSE_STATUS,
  RESET_RATING
} from './rateAnAdviserContainerActions'

const initialState = {
  submittedStatus: 'PENDING',
  adviserId: null,
  selectedMetAdviser: null,
  selectedAppointAdviser: null,
  enteredEmail: '',
  givenRatings: {
    serviceReceived: 0,
    understandingOfNeeds: 0,
    understandingOfMatters: 0,
    disclosedFees: 0,
    wouldRecommend: 0
  },
  isInvalid: {
    formIsValid: false,
    MetAdviserContainer: {
      isInvalid: false,
      message: null,
      valid: false,
      pristine: true
    },
    AppointAdviserContainer: {
      isInvalid: false,
      message: null,
      valid: false,
      pristine: true
    },
    EmailContainer: {
      isInvalid: false,
      message: null,
      valid: false,
      pristine: true
    },
    RatingsContainer: {
      isInvalid: false,
      message: null,
      valid: false,
      pristine: true
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)

  function formIsValid (currentState) {
    return currentState.isInvalid.EmailContainer.valid &&
      currentState.isInvalid.AppointAdviserContainer.valid &&
      currentState.isInvalid.MetAdviserContainer.valid &&
      currentState.isInvalid.RatingsContainer.valid
  }

  switch (action.type) {

    case VALIDATE_RATING: {
      if (action.specificComponent == null) {
        action.specificComponent = 'All'
      }

      if (action.specificComponent === 'metAdviser' || action.specificComponent === 'All') {
        if (newState.selectedMetAdviser === null || newState.selectedMetAdviser === undefined) {
          newState.isInvalid.MetAdviserContainer = {
            isInvalid: true,
            message: 'Please indicate whether or not you have met this Financial Adviser',
            valid: false,
            pristine: false
          }
        } else {
          newState.isInvalid.MetAdviserContainer = {
            validationstate: 'success',
            message: null,
            valid: true,
            pristine: false
          }
        }
      }

      if (action.specificComponent === 'appointAdviser' || action.specificComponent === 'All') {
        if (newState.selectedAppointAdviser === null || newState.selectedAppointAdviser === undefined) {
          newState.isInvalid.AppointAdviserContainer = {
            isInvalid: true,
            message: 'Please indicate whether or not you appointed this Financial Adviser',
            valid: false,
            pristine: false
          }
        } else {
          newState.isInvalid.AppointAdviserContainer = {
            validationstate: 'success',
            message: null,
            valid: true,
            pristine: false
          }
        }
      }

      if (action.specificComponent === 'email' || action.specificComponent === 'All') {
        if (newState.enteredEmail === '' || newState.enteredEmail === undefined) {
          newState.isInvalid.EmailContainer = {
            isInvalid: true,
            message: 'Please enter a valid Email',
            valid: false,
            pristine: false
          }
        } else {
          newState.isInvalid.EmailContainer = {
            validationstate: 'success',
            message: null,
            valid: true,
            pristine: false
          }
        }
      }

      if (action.specificComponent === 'ratings' || action.specificComponent === 'All') {
        if (Object.values(newState.givenRatings).indexOf(0) > -1) {
          newState.isInvalid.RatingsContainer = {
            isInvalid: true,
            message: 'Please submit all ratings',
            valid: false,
            pristine: false
          }
        } else {
          newState.isInvalid.RatingsContainer = {
            validationstate: 'success',
            message: null,
            valid: true,
            pristine: false
          }
        }
      }

      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case SET_METADVISOR: {
      newState.selectedMetAdviser = action.value
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case SET_ADVISER_ID: {
      newState.adviserId = action.adviserId
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case SET_APPOINTADVISOR: {
      newState.selectedAppointAdviser = action.value
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case SET_EMAIL: {
      const nextState = {
        ...state,
        enteredEmail: action.value,
        isInvalid: {
          ...state.isInvalid,
          EmailContainer: {
            isInvalid: action.validationResult.isInvalid,
            help: action.validationResult.help,
            valid: action.validationResult.valid,
            pristine: action.validationResult.pristine
          }
        }
      }

      nextState.isInvalid.formIsValid = formIsValid(nextState)
      return nextState
    }

    case SET_RATING: {
      if (action.ratingType === 'serviceReceived') {
        newState.givenRatings.serviceReceived = parseInt(action.value)
        newState.isInvalid.formIsValid = formIsValid(newState)
      }
      if (action.ratingType === 'understandingOfNeeds') {
        newState.givenRatings.understandingOfNeeds = parseInt(action.value)
        newState.isInvalid.formIsValid = formIsValid(newState)
      }
      if (action.ratingType === 'understandingOfMatters') {
        newState.givenRatings.understandingOfMatters = parseInt(action.value)
        newState.isInvalid.formIsValid = formIsValid(newState)
      }
      if (action.ratingType === 'disclosedFees') {
        newState.givenRatings.disclosedFees = parseInt(action.value)
        newState.isInvalid.formIsValid = formIsValid(newState)
      }
      if (action.ratingType === 'wouldRecommend') {
        newState.givenRatings.wouldRecommend = parseInt(action.value)
        newState.isInvalid.formIsValid = formIsValid(newState)
      }
      return newState
    }

    case SUBMITTING_RATING: {
      newState.submitting = true
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case SET_RESPONSE_STATUS: {
      newState.submittedStatus = action.responseStatus
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }

    case RESET_RATING: {
      return cloneDeep(initialState)
    }

    case SUBMITTED_RATING: {
      newState = cloneDeep(initialState)
      newState.isInvalid = { formIsValid: initialState.isInvalid.formIsValid }
      newState.isInvalid.MetAdviserContainer =
        cloneDeep(initialState.isInvalid.MetAdviserContainer)
      newState.isInvalid.AppointAdviserContainer =
        cloneDeep(initialState.isInvalid.AppointAdviserContainer)
      newState.isInvalid.EmailContainer =
        cloneDeep(initialState.isInvalid.EmailContainer)
      newState.isInvalid.RatingsContainer =
        cloneDeep(initialState.isInvalid.RatingsContainer)
      newState.submittedStatus = 'SUBMITTED'
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    }
  }
  return state
}
